import React from "react";

export const InitialPloca = () => {
  return (
    <svg
      width="78"
      height="55"
      viewBox="0 0 78 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3086 8.78516L18.3242 53.9688H14.6426V8.78516H21.3086Z"
        fill="#264D51"
        stroke="#264D51"
        strokeWidth="0.836735"
      />
      <path
        d="M64.0107 8.78516V53.9688H60.3291L57.3447 8.78516H64.0107Z"
        fill="#264D51"
        stroke="#264D51"
        strokeWidth="0.836735"
      />
      <path
        d="M77.3984 0.417969V8.78613H0.417969V0.417969H77.3984Z"
        stroke="#264D51"
        strokeWidth="0.836735"
      />
    </svg>
  );
};
